// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Components
import { FooterComponent } from '@openbank/ziniaweb-ui-components';
// Constants
import {
  AUTH_WATCHER_FOOTER_FOOTER_ACTION_PROPS,
  AUTH_WATCHER_FOOTER_FOOTER_ACTION_LINK_PROPS,
} from './constants/auth-watcher-footer.constants';
// Enumerations
import { AuthScenariosEnumeration } from '../../enumerations/auth-scenarios.enumeration';
// Hooks
import { useAuthWatcherFooterHook } from './hooks/auth-watcher-footer.hook';
// Translations
import { AUTH_WATCHER_FOOTER_BUTTONS } from './translations/auth-watcher-footer.translations';
// Styles
import { AuthWatcherFooterComponentStyled } from './auth-watcher-footer.component.styled';
// Types
import type { AuthWatcherHookType } from 'providers/auth-watcher/hooks/types/auth-watcher.hook.type';

const AuthWatcherFooterComponent = ({
  authConflict,
  ...restProps
}: AuthWatcherHookType): React.ReactNode => {
  const { fetching, handleAuthWatcherModalMainButtonClick } = useAuthWatcherFooterHook({
    authConflict,
    ...restProps,
  });

  return (
    <AuthWatcherFooterComponentStyled>
      <FooterComponent
        {...AUTH_WATCHER_FOOTER_FOOTER_ACTION_PROPS}
        mainButtonConfiguration={{
          ...AUTH_WATCHER_FOOTER_FOOTER_ACTION_LINK_PROPS,
          children: (
            <FormattedMessage
              id={AUTH_WATCHER_FOOTER_BUTTONS[authConflict as AuthScenariosEnumeration]}
            />
          ),
          loading: fetching,
          onClick: handleAuthWatcherModalMainButtonClick,
        }}
      />
    </AuthWatcherFooterComponentStyled>
  );
};

export { AuthWatcherFooterComponent };
